import React from "react";

import { DatePicker, Icon } from "antd";
import moment from "moment";

export const SelectedDayMap = ({ onDatePicked, events, currentDate }) => (
  <div className="flex items-center m-5 justify-center">
    <button
      className="rounded-full h-10 w-10 flex items-center justify-center"
      style={{ outline: "none" }}
      onClick={() => {
        onDatePicked(moment(currentDate).add(-1, "day"));
      }}
    >
      <Icon type="left" />
    </button>
    <div style={{ fontSize: 30 }}>
      <DatePicker
        allowClear={false}
        onChange={onDatePicked}
        defaultValue={moment()}
        value={moment(currentDate)}
        dateRender={current => {
          const style = {};

          if (Array.isArray(events) && events.some(event => current.isSame(event.start_date, "day"))) {
            style.border = "1px solid #ec841d";
            style.borderRadius = "50%";
          }
          return (
            <div className="ant-calendar-date" style={style}>
              {current.date()}
            </div>
          );
        }}
      />
    </div>
    {
      <button
        className="rounded-full h-10 w-10 flex items-center justify-center"
        style={{ outline: "none" }}
        onClick={() => {
          onDatePicked(moment(currentDate).add(1, "day"));
        }}
      >
        <Icon type="right" />
      </button>
    }
  </div>
);



// WEBPACK FOOTER //
// src/containers/activite/map/SelectDayMap.js